<template>
    <Form :schema="schema" @submit="submit" :values="user_data" v-slot="{ errors, success }"
        :class="['change-email-form', { 'is-error': is_error, 'is-loading': is_loading }]" ref="form">

        <!-- <div class="small-label">Email - <span v-if="!edit_email">Verified</span></div> -->
        <div class="small-label">Email</div>

        <Loading class="static" v-if="is_loading" />
        <div class="small-label-text" v-if="!edit_email && !is_loading">{{ $store.state.user_data.email }} 
            <a v-if="!$store.state.user_data.is_okta_user" @click="$emit('handleChangeEmail')">Change email</a></div>
        <div class="email-input" v-if="edit_email && !is_loading">

            <div class="step-1" v-if="step === 1">
                <div class="edit-input-title">New email</div>
                <Field type="text" :is_clear="true" k="email" placeholder="New email" :default_value="user_data.email"
                    :error_msg="errors.email" :is_success="success.email" @update="update" :ref="(el) => { els.push(el) }"
                    :key="email" :handle_err="result !== 'success' && result !== ''"/>
                <div class="err-msg-box-email"  v-if="step == 1 && result && result !== 'success'">
                    <p class="error-email-msg" v-html="result"></p>
                    <i><svg-icon name="alert" class="icon-left" /></i>
                </div>
            </div>

            <div class="step-2 code-box" v-if="step === 2">
                <p>
                    We have sent a 6-digit verification code to <span class="link">{{ user_data.email }}</span>. This code will expire in 5 minutes.
                </p>

                
                <VerificationCode ref="code" @resend="sendEmail" :countdown="countdown" :error_msg="code_error_msg"
                    @update="update"
                    :class="[{ 'success': code.length === 6 && !code_error }, { 'error': code_error }]" />
                
            </div>
            <div class="btn-box">
                <el-button @click="$emit('handleChangeEmail')">Cancel</el-button >
                <Button type="submit" color="dark-blue" size="32" :is_disabled="!can_next" :key="can_next" :border_r="6">{{ btn_word
                }}</Button>

            </div>
        </div>
    </Form>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import VerificationCode from '@/components/ui/VerificationCode.vue';
import Loading from '@/components/ui/Loading.vue';
import * as yup from 'yup';
import { ElButton } from 'element-plus';

export default {
    name: 'AccountEmail',

    components: {
        Field,
        Form,
        Button,
        VerificationCode,
        Loading,
        ElButton
    },

    props: {
        email: {
            type: String,
            default: ''
        },
        edit_email: {
            type: Boolean,
            default: ''
        }
    },
    emits: [
        'handleChangeEmail'
    ],

    data() {
        return {
            is_loading: false,
            user_data: {
                email: '',
            },
            els: [],
            schema: yup.object().shape({
                email: yup.string().required('The email can’t leave as blank')
                .email('Please use correct email format')
                .test('email-unique', 'Please use another email.', this.customEmailValidation),
            }),
            is_error: false,
            is_send_email: false,
            result: '',
            //code
            code: '',
            code_error: false,
            code_error_msg: '',
            countdown_timer: null,//sendEmail
            countdown_second: 300,//sendEmail
            countdown: 0,//sendEmail
        }
    },

    watch: {
        edit_email(val) {
            if (val) {
                this.start();
            }
        },
    },

    computed: {
        btn_word() {
            let text = '';
            if (this.step == 2) {
                text = 'Confirm';
            } else {
                text = 'Next';
            };
            return text;
        },

        step() {
            if (this.is_send_email && this.result == 'success') {
                return 2;
            } else {
                return 1;
            }
        },

        can_next() {
            return (this.step ==1 && this.user_data.email !== '') || (this.step == 2 && this.code.length == 6);
        }
    },

    methods: {
        start() {
            this.user_data.email = '';
            setTimeout(() => {
                this.els.forEach(el => {
                    if (el) el.sync();
                });

                // setTimeout(() => {
                //     this.$refs.form.init();
                // }, 300);

            }, 100);
        },

        customEmailValidation(value) {
            return this.$store.state.user_data.email !== value;
        },

        update(obj) {
            this.is_error = false;
            this.error_msg = '';
            
            switch (this.step) {
                case 1:
                    Object.keys(this.user_data).forEach(key => {
                        if (key === obj.key) this.user_data[key] = obj.val;
                    });
                    this.result ='';
                    break;

                case 2:
                    this.code = '';
                    for (let index = 0; index < obj.length; index++) {
                        if (obj[index]) this.code = this.code + obj[index];
                    }

                    // console.log(this.code)

                    if (this.code.length === 6) {
                        this.code_error = false;
                        this.code_error_msg = '';

                        this.checkCode();
                    }

                    break;
            }

        },

        sendEmail() {
            this.is_send_email = true;
            this.is_loading = true;
            this.countdown = this.countdown_second;
            this.countdown_timer = window.setInterval(() => {
                this.countdown--;

                if (this.countdown === 0) {
                    window.clearInterval(this.countdown_timer);
                }
            }, 1000);
            this.$ajax('/settings/send-update-login-user-email', {
                method: 'post',
                data: {
                    email: this.user_data.email,
                },
            }).then(() => {
                this.result = 'success';
                this.is_loading = false;
            }).catch((err) => {
                this.is_send_email = false;
                if (err && err.response && err.response.data.data) {
                    this.result = err.response.data.data.message;
                }
                this.is_loading = false;
            });

        },

        checkCode() {

            this.is_loading = true;

            this.$ajax('/settings/update-login-user-email', {
                method: 'post',
                data: {
                    email: this.user_data.email,
                    code: this.code,
                },
            }).then(res => {
                this.is_loading = false;
                this.$emit('handleChangeEmail', { email: this.user_data.email });
                this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Email updated');
            }).catch(err => {
                this.is_loading = false;
                this.code='';
                if (err && err.response && err.response.data.data) {
                    this.code_error = true;

                    if (err.response.data.data.message === 'code is invalid, email not updated') {
                        this.code_error_msg = 'Invalid code.';
                    } else {
                        this.code_error_msg = err.response.data.data.message;
                    }
                }
            });

        },

        submit() {
            if (this.can_next) {
                this.is_error = false;
                if (this.step == 1) {
                    this.sendEmail();
                } else {
                    this.checkCode()
                }
            }
        },
    },

    mounted() {
        this.start();
    },
}
</script>
<style lang="scss" scoped>

.code-box {
    display: flex;

    & > p {
        flex: 1;
        color: var(--black-75);
        margin-right: 16px;
        font-family: var(--font);
        font-size: 14px;
        font-weight: 500;

        .link {
            color: var(--blue);
        }
    }
}
.email-input {
    background: var(--light-neutral);
    padding: 13px;

    .ui-input {
        width: 100%;
        margin-right: 10px;
        margin-bottom: 15px;
    }

    .err-msg-box-email{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: -16px;
        font-family: var(--font);
        font-weight: 500;

        .error-email-msg {
            margin: 4px;
            color: var(--alert);
            text-align: right;
            font-size: 12px;
        }

        i{
            width: 14px;
            height: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 5px;
        }

        svg{
            width: 10.5px;
            height: 10.5px;
            fill:var(--alert);
        }
    }




    .disabled {
        color: var(--black-40) !important;
        background-color: var(--black-10) !important;
        border: solid 1px var(--black-20) !important;
    }

}

.edit-input-title,
.verification-code label {
    font-family: var(--font);
    font-weight: 500;
    font-size: 10px;
    color: var(--black-60);
    margin-bottom:8px;
}

.step-2 {
    display: flex;
    justify-content: space-between;

    @at-root {
        @media screen and (max-width: 1388px) {
            & {
                display: block;

                .verification-code .list {
                    margin: 0 auto;
                }
            }
        }
      
    }
  
    
}

.verification-code {

    header {
        padding: 0;
    }

    .list input {

        &:first-child {
            margin: 0 4px 0 0;
        }
    }
}

.btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap:8px;
}
</style>

